import { useEffect } from 'react'

/**
 * Native <details>/<summary> elements toggle open via summary clicks
 * but do NOT close on outside clicks - that's a browser default the
 * source HTML inherits. The top-nav "Products" dropdown is the only
 * <details> on the page, so we attach a single document-level listener
 * that closes any open <details> when the user clicks anywhere outside
 * its <summary>, or presses Escape.
 *
 * The source's own click handler already closes the dropdown when the
 * user follows an in-app nav link inside it; this overlay covers the
 * remaining cases: outside-click, click on an external link inside the
 * dropdown (e.g. https://pentabay.com/ava), and keyboard dismissal.
 */
export default function DetailsAutoClose() {
  useEffect(() => {
    function onClick(e) {
      const opened = document.querySelectorAll('details[open]')
      if (opened.length === 0) return
      // If the click landed on ANY <summary> (including a nested one
      // inside an open <details>), find that summary. We must spare
      // every ancestor <details> of that summary - otherwise opening
      // a nested submenu would also collapse its parent panel.
      const clickedSummary = e.target.closest('summary')
      opened.forEach((det) => {
        // Spare this details if the click was on a summary inside it
        // (its own, or any nested submenu's summary). Native toggle
        // handles the summary itself.
        if (clickedSummary && det.contains(clickedSummary)) return
        det.removeAttribute('open')
      })
    }
    function onKey(e) {
      if (e.key !== 'Escape') return
      document.querySelectorAll('details[open]').forEach((det) => {
        det.removeAttribute('open')
      })
    }
    document.addEventListener('click', onClick)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('click', onClick)
      document.removeEventListener('keydown', onKey)
    }
  }, [])
  return null
}
